function getApiBaseUrl() {
  if (typeof window !== 'undefined' && window.API_BASE_URL) {
    return window.API_BASE_URL;
  }
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return 'http://localhost:35001/api';
  }
  return '/api';
}

const API_BASE_URL = getApiBaseUrl();

const TEXT = {
  en: {
    sending: 'Sending...',
    success: 'Message sent. Thank you!',
    messageRequired: 'Please enter a message.',
    invalidEmail: 'Please enter a valid email address.',
    serverUnavailable: 'Mail service is not configured yet.',
    failed: 'Failed to send. Please try again later.'
  },
  zh: {
    sending: '发送中...',
    success: '已发送，感谢你的留言！',
    messageRequired: '请输入消息内容。',
    invalidEmail: '请输入有效邮箱地址。',
    serverUnavailable: '邮箱服务暂未配置完成。',
    failed: '发送失败，请稍后重试。'
  }
};

function getLangText(key) {
  const lang = document.documentElement.lang === 'zh' ? 'zh' : 'en';
  return TEXT[lang][key] || TEXT.en[key] || '';
}

function setStatus(statusEl, type, text) {
  if (!statusEl) return;
  statusEl.textContent = text || '';
  statusEl.classList.remove('is-error', 'is-success');
  if (type === 'error') statusEl.classList.add('is-error');
  if (type === 'success') statusEl.classList.add('is-success');
}

let initialized = false;

export default function initHeroContactForm() {
  if (initialized) return;

  const form = document.getElementById('hero-message-form');
  if (!form) return;

  initialized = true;

  const statusEl = document.getElementById('hero-message-status');
  const submitBtn = form.querySelector('button[type="submit"]');
  const messageInput = form.querySelector('textarea[name="message"]');
  const emailInput = form.querySelector('input[name="email"]');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const formData = new FormData(form);
    const name = String(formData.get('name') || '').trim();
    const email = String(formData.get('email') || '').trim();
    const message = String(formData.get('message') || '').trim();
    const website = String(formData.get('website') || '').trim();

    if (website) {
      setStatus(statusEl, 'success', getLangText('success'));
      form.reset();
      return;
    }

    if (!message) {
      setStatus(statusEl, 'error', getLangText('messageRequired'));
      messageInput?.focus();
      return;
    }

    if (emailInput && email && !emailInput.checkValidity()) {
      setStatus(statusEl, 'error', getLangText('invalidEmail'));
      emailInput.focus();
      return;
    }

    const payload = {
      name,
      email,
      message,
      source: 'hero',
      pageUrl: window.location.href,
      language: document.documentElement.lang || 'en',
      userAgent: navigator.userAgent
    };

    submitBtn.disabled = true;
    setStatus(statusEl, null, getLangText('sending'));

    try {
      const response = await fetch(`${API_BASE_URL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        mode: 'cors',
        credentials: 'omit',
        body: JSON.stringify(payload)
      });

      let data = null;
      try {
        data = await response.json();
      } catch (_) {
        data = null;
      }

      if (!response.ok) {
        if (response.status === 503) {
          throw new Error('server_unavailable');
        }
        throw new Error(data?.error || 'request_failed');
      }

      setStatus(statusEl, 'success', getLangText('success'));
      form.reset();
    } catch (error) {
      console.error('Failed to submit hero contact form:', error);
      if (error.message === 'server_unavailable') {
        setStatus(statusEl, 'error', getLangText('serverUnavailable'));
      } else {
        setStatus(statusEl, 'error', getLangText('failed'));
      }
    } finally {
      submitBtn.disabled = false;
    }
  });
}
